import moment from 'moment';

export const convertYearInputToPayload = (date) => {
  if (!date) return '';
  const m = moment(date, 'DD/MM/YYYY', true);
  return m.isValid() ? m.format('YYYY-MM-DD') : '';
};

/**
 * Warranty API expects a calendar date string (not `YYYY-MM-DD HH:mm:ss`; that layout often fails server parsing).
 * Form DATE_PICKER stores DD/MM/YYYY.
 */
export const convertDateInputToPayload = (date) => {
  if (date === null || date === undefined || date === '') return '';
  const str = typeof date === 'string' ? date.trim() : String(date);
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const iso = moment(str);
    return iso.isValid() ? iso.format('YYYY-MM-DD') : '';
  }
  const parsed = moment(str, 'DD/MM/YYYY', true);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};
